import { atomFamily } from "jotai/utils";
import { atomPersistor } from "./atomPersistor";

const sessionFinishedAtom = atomFamily((sessionId: string | undefined) =>
  atomPersistor(`${sessionId}-sessionFinished`, false)
);

export { sessionFinishedAtom };
